export default __webpack_public_path__ + "static/media/Touch-App-Geraeteabbildung_DURAG_1400TRX_675x267px.85362b23.png";